import { render, staticRenderFns } from "./TeamGrid.vue?vue&type=template&id=6f08a958&scoped=true&"
import script from "./TeamGrid.vue?vue&type=script&lang=js&"
export * from "./TeamGrid.vue?vue&type=script&lang=js&"
import style0 from "./TeamGrid.vue?vue&type=style&index=0&id=6f08a958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f08a958",
  null
  
)

export default component.exports